import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import URLS from "redux/urls";
import request from "redux/utils/request";

export const fetchAllActivity = createAsyncThunk(
  "Activity/fetchAllActivity",
  async (params, { rejectWithValue }) => {
    try {
      const response = await request("get", URLS.ACTIVITY, params);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const addActivity = createAsyncThunk(
  "Activity/addActivity",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await request("post", URLS.ACTIVITY, payload);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateActivity = createAsyncThunk(
  "Activity/updateActivity",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await request(
        "patch",
        `${URLS.ACTIVITY}/${payload.id}`,
        payload
      );
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
export const fetchOneActivity = createAsyncThunk(
  "Activity/fetchOneActivity",
  async (id, { rejectWithValue }) => {
    try {
      const response = await request("get", `${URLS.ACTIVITY}/${id}`);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteActivity = createAsyncThunk(
  "Activity/deleteActivity",
  async (id, { rejectWithValue }) => {
    try {
      const response = await request("delete", `${URLS.ACTIVITY}/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const initialState = {
  loading: {
    query: false,
    mutation: false,
  },
  filter: {
    q: "",
  },
  list: [],
  count: {},
  selected: {},
  selectedRows: [],
};

const loadingReducer = (fieldName, status) => (state) => {
  state.loading[fieldName] = status;
};

const startLoadingQuery = loadingReducer("query", true);
const stopLoadingQuery = loadingReducer("query", false);
const startLoadingMutation = loadingReducer("mutation", true);
const stopLoadingMutation = loadingReducer("mutation", false);

export const ActivitySlice = createSlice({
  name: "Activity",
  initialState,
  reducers: {
    setAppliedSearchText: (state, action) => {
      state.filter.q = action.payload;
    },
    setSelectedRows: (state, action) => {
      state.selectedRows = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllActivity.pending, startLoadingQuery)
      .addCase(fetchAllActivity.fulfilled, (state, action) => {
        state.list = action.payload;
        state.loading.query = false;
      })
      .addCase(fetchAllActivity.rejected, stopLoadingQuery);
    builder
      .addCase(fetchOneActivity.pending, startLoadingQuery)
      .addCase(fetchOneActivity.rejected, stopLoadingQuery)
      .addCase(fetchOneActivity.fulfilled, (state, action) => {
        state.loading.query = false;
        state.selected = action.payload;
      });
    builder
      .addCase(updateActivity.pending, startLoadingQuery)
      .addCase(updateActivity.rejected, stopLoadingQuery)
      .addCase(updateActivity.fulfilled, (state, action) => {
        state.loading.query = false;
        state.selected = action.payload;
      });
    builder
      .addCase(deleteActivity.pending, startLoadingMutation)
      .addCase(deleteActivity.fulfilled, stopLoadingMutation)
      .addCase(deleteActivity.rejected, stopLoadingMutation);
  },
});

export const { setSelectedRows, setAppliedSearchText } = ActivitySlice.actions;

export default ActivitySlice.reducer;
